import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_DETAIL_API_ID_IMAGE =
  'DASHBOARD/FETCH_INVESTCORE_USER_DETAIL_API_ID_IMAGE,';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_DETAIL_API_ID_IMAGE,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/identification-images/latest`,
    method: 'GET',
  })
);

export default apiCall;
